import { useEffect } from "react";
import { Form } from "antd";
import { Rule } from "antd/lib/form";
import { useRouter } from "next/router";

export const useResetPassword = () => {
	const [form] = Form.useForm();

	const router = useRouter();
	const { id } = router.query;

	useEffect(() => {
		if (!id.includes("id")) {
			router.push("/");
		}
	}, [id]);

	// Response Reset Password Form
	const changePassword = values => {
		console.log("Received values of form: ", values);
	};

	// Validates
	const validateForm = {
		required: "Este campo es requerido!",
	};

	const validateRules: { [x: string]: Rule[] } = {
		password: [
			{ required: true },
			{
				min: 8,
				message: "La contraseña debe ser de mínimo 8 carácteres!",
			},
		],
		confirm: [
			{ required: true },
			({ getFieldValue }) => ({
				validator(_, value) {
					if (!value || getFieldValue("password") === value) {
						return Promise.resolve();
					}
					return Promise.reject("Las contraseñas no coinciden!");
				},
			}),
		],
	};

	return {
		form,
		changePassword,
		validate: { validateForm, validateRules },
	};
};
